import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#111111',
      contrastText: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 700,
          borderRadius: 9999,
          paddingInline: 18,
          paddingBlock: 8,
          lineHeight: 1.2,
          boxShadow: '0 1px 0 rgba(0,0,0,0.20), inset 0 -2px 0 rgba(255,255,255,0.06)',
          border: '1px solid #2b2b2b',
        },
        contained: {
          backgroundColor: '#2b2b2b',
          color: '#fff',
        },
        containedPrimary: {
          backgroundColor: '#2b2b2b',
          '&:hover': {
            backgroundColor: '#1f1f1f',
          },
          '&:active': {
            backgroundColor: '#1a1a1a',
          },
          '&:disabled': {
            color: 'rgba(255,255,255,0.6)',
            backgroundColor: '#3a3a3a',
          },
        },
        sizeSmall: {
          paddingInline: 14,
          paddingBlock: 6,
          borderRadius: 9999,
        },
        sizeLarge: {
          paddingInline: 22,
          paddingBlock: 10,
          borderRadius: 9999,
        },
      },
    },
  },
});

export default theme;
